import { z } from 'zod';

import { getWordCount } from '@rover/utilities/wordCount';

export const getTextAreaSchema = (minWordCount: number) =>
  z.string().refine((val) => (getWordCount(val) || 0) >= minWordCount, {
    message: `Please write at least ${minWordCount} words`,
  });
